const common = {
  'brand': 'USFans Spreadsheet',
  'nav.home': 'Inicio',
  'nav.shoppingGuide': 'Guía de compra',
  'nav.categories': 'Categorías',
  'nav.guides': 'Guías',
  'nav.reviews': 'Reseñas',
  'nav.safety': 'Seguridad',
  'nav.cta': 'Comprar Ahora',
  'common.readMore': 'Leer más',
  'common.updated': 'Actualizado',
  'common.mainSite': 'Visitar sitio principal',
  'common.backHome': 'Volver al inicio',
  'footer.tagline': 'Un centro de recursos independiente que te ayuda a organizar los recursos de la hoja de cálculo de USFans, listas de productos, información de vendedores y guías de compra en un solo lugar.',
  'footer.navTitle': 'Navegación',
  'footer.resourcesTitle': 'Recursos',
  'footer.categories': 'Categorías',
  'footer.guides': 'Guías',
  'footer.reviews': 'Reseñas',
  'footer.safety': 'Centro de seguridad',
  'footer.disclaimer': 'Este sitio web es un recurso informativo independiente. Verifica siempre de forma independiente los sitios web, vendedores, enlaces, precios y detalles de las transacciones antes de realizar cualquier acción.',
  'footer.rights': 'Todos los derechos reservados.',
  'lang.english': 'English',
  'lang.polish': 'Polski',
  'lang.spanish': 'Español',
  'lang.french': 'Français',
};

export default common;